import { Controller } from '@hotwired/stimulus'

// kopiuje numer przesyłki do schowka
export default class extends Controller {
  static targets = ['source', 'button']

  async copy() {
    try {
      await navigator.clipboard.writeText(this.sourceTarget.textContent.trim())
      this.buttonTarget.textContent = 'Skopiowano'
    } catch {
      this.buttonTarget.textContent = 'Zaznacz i skopiuj'
    }
    setTimeout(() => { this.buttonTarget.textContent = 'Kopiuj' }, 2000)
  }
}
